// extracted by css-extract-rspack-plugin
export default {"item":"pW92b","active":"yZDsH","link":"o0S2v"};